import { createFileRoute } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { z } from 'zod';

import { DashboardInsightViews } from '~/features/insights/os/insight-views';

/** A Dashboard insight changed by asking (board dashboard-os-edit-ask), or in the one insight editor with `by=hand`. */
const search = z.object({ by: z.enum(['hand']).optional() });

function EditorRoute(): ReactElement {
  const { cardId } = Route.useParams();
  const { by } = Route.useSearch();
  const navigate = Route.useNavigate();
  return <DashboardInsightViews key={cardId} cardKey={cardId} by={by ?? null} onBy={(next) => void navigate({ search: next === null ? {} : { by: next } })} />;
}

export const Route = createFileRoute('/_app/dashboard/$cardId/edit')({
  validateSearch: search,
  component: EditorRoute,
});
